(function () {
  'use strict';

  function updateNoticeFromElement(notice, source) {
    if (!notice || !source) return;
    notice.hidden = source.hidden;
    notice.innerHTML = source.innerHTML;
  }

  class BackorderNotice extends HTMLElement {
    connectedCallback() {
      this.onVariantChange = this.onVariantChange.bind(this);
      this.onPubsubVariantChange = this.onPubsubVariantChange.bind(this);

      var form = this.closest('form[is="product-form"], form.product-form');
      if (form) {
        form.addEventListener('variant:change', this.onVariantChange);
      }

      if (window.theme && window.theme.pubsub && typeof window.theme.pubsub.subscribe === 'function') {
        this._unsubVariantChange = window.theme.pubsub.subscribe(
          window.theme.pubsub.PUB_SUB_EVENTS.variantChange,
          this.onPubsubVariantChange
        );
      }
    }

    disconnectedCallback() {
      var form = this.closest('form[is="product-form"], form.product-form');
      if (form) {
        form.removeEventListener('variant:change', this.onVariantChange);
      }

      if (typeof this._unsubVariantChange === 'function') {
        this._unsubVariantChange();
      }
    }

    onVariantChange(event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      this.refreshForVariant(variant.id);
    }

    onPubsubVariantChange(event) {
      var data = event && event.data;
      if (!data || !data.parsedHTML) return;

      var sectionId = this.getAttribute('data-section-id');
      if (sectionId && data.sectionId && String(data.sectionId) !== String(sectionId)) return;

      var newNotice = data.parsedHTML.querySelector('backorder-notice');
      if (!newNotice) {
        this.hidden = true;
        this.innerHTML = '';
        return;
      }

      updateNoticeFromElement(this, newNotice);
    }

    refreshForVariant(variantId) {
      var sectionId = this.getAttribute('data-section-id');
      if (!sectionId || !variantId) return;

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var url =
        root +
        '?section_id=' +
        encodeURIComponent(sectionId) +
        '&variant=' +
        encodeURIComponent(String(variantId));

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newNotice = doc.querySelector('backorder-notice');
          if (!newNotice) {
            this.hidden = true;
            this.innerHTML = '';
            return;
          }
          updateNoticeFromElement(this, newNotice);
        }.bind(this))
        .catch(function () {});
    }
  }

  if (!customElements.get('backorder-notice')) {
    customElements.define('backorder-notice', BackorderNotice);
  }
})();
